import { render } from "./GroupView.vue?vue&type=template&id=74859a2c"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__